import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16 md:pb-20">
        <div className="px-4 md:px-6 max-w-[800px] mx-auto">
          <nav className="text-xs text-foreground-500 mb-6" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-foreground-900 cursor-pointer transition-colors">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-foreground-700 font-medium">Privacy Policy</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-8">Privacy Policy</h1>

          <div className="space-y-6 text-foreground-700 leading-relaxed text-sm">
            <p><strong>Ultimo aggiornamento:</strong> Luglio 2026</p>

            <p>
              La presente Privacy Policy descrive come itaobuyspread.pics raccoglie, utilizza e protegge 
              le informazioni degli utenti che visitano il nostro sito web.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Dati Raccolti</h2>
            <p>
              Il nostro sito non raccoglie attivamente dati personali degli utenti. Non utilizziamo 
              form di registrazione, non richiediamo email e non memorizziamo informazioni personali 
              sui nostri server. Il sito funziona come portale informativo con link esterni al sito 
              principale Kaspreadsheet.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Cookie</h2>
            <p>
              itaobuyspread.pics utilizza solo cookie tecnici essenziali per il funzionamento del sito. 
              Non utilizziamo cookie di profilazione, cookie pubblicitari o cookie di terze parti per 
              il tracciamento degli utenti.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Link Esterni</h2>
            <p>
              Il nostro sito contiene link al sito esterno Kaspreadsheet e ad altri marketplace. 
              Non siamo responsabili delle pratiche sulla privacy di questi siti terzi. Ti invitiamo 
              a consultare le rispettive privacy policy.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Contatti</h2>
            <p>
              Per domande sulla presente Privacy Policy, visita il nostro sito principale{' '}
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 cursor-pointer">
                Kaspreadsheet
              </a>.
            </p>

            <div className="mt-8">
              <Link to="/" className="text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer transition-colors">
                &larr; Torna alla Home
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Privacy Policy - Itaobuy Spreadsheet',
            url: 'https://itaobuyspread.pics/privacy-policy',
            description: 'Privacy Policy di itaobuyspread.pics. Informazioni su come raccogliamo, utilizziamo e proteggiamo i dati degli utenti.',
            inLanguage: 'it',
            dateModified: '2026-07-14',
          }),
        }}
      />
    </>
  );
}